import router from './router'
import store from './store'
import {Message} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import {getToken,getUsername} from '@/utils/auth'
import de from "element-ui/src/locale/lang/de"; // getToken from cookie

NProgress.configure({showSpinner: false})// NProgress Configuration

const whiteList = ['/public']// no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  // 管理页面
  if (to.path.startsWith('/admin')) {
    if (getToken()) {
      if (to.path === '/admin/login') {
        next({path: '/'})
        NProgress.done()
      } else {
        if (!store.getters.username && !getUsername()) { // 判断当前用户是否已拉取完user_info信息
          store.dispatch('FedLogOut').then(() => {
            next({path: '/admin/'})
          })
        } else {
          next()
          NProgress.done()
        }
      }
    } else {
      if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
        next()
      } else if (to.path === '/admin/login') {
        next()
      } else {
        next(`/admin/login?redirect=${to.path}`) // 否则全部重定向到登录页
        NProgress.done()
      }
    }
  } else {
    next()
    NProgress.done()
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js